<template>
    <el-card class="box-card">

        <el-dialog
            title="信息更新结果"
            :visible.sync="resultShow"
            width="50%" lock-scroll
            center
        >
            <el-table :data="resultArray"
                      row-key="id + '_' + server_url"
                      stripe
                      style="width: 100%;"
                      :default-sort="{prop: 'id'}"
            >
                <el-table-column prop="server_name" label='服务器名' width="160" fixed></el-table-column>
                <el-table-column prop="server_url" label='请求地址' width="500"></el-table-column>
                <el-table-column prop="resStatus" label='响应结果' width="150"></el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resultShow = false">关闭</el-button>
            </div>
        </el-dialog>

        <div class="query-panel">
            <el-form :inline="true">
                <el-form-item>
                    <el-button size="small" type="primary" @click="showCreateNotice">创建公告</el-button>
                    <el-button size="small" type="primary" @click="showUploadBanner">轮播图设置</el-button>
                    <el-button size="small" type="danger" @click="dotTipsPush">公告红点推送</el-button>
                </el-form-item>
            </el-form>
        </div>

        <el-tabs type="border-card" v-model="activeName" @tab-click="noticeTabClick">
            <el-tab-pane label="公告列表" name="first">
                <el-table :data="dataHandled" border>
                    <el-table-column prop="lang" width="150px" label="公告语言">
                        <template slot-scope="scope">
                            <span v-for="item in noticeLangOptions" v-if="item.value==scope.row.lang">{{item.label}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="title" width="150px" label="公告标题"></el-table-column>
                    <el-table-column  width="150px" label="公告类型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.type === 'picContent'">图片公告</span>
                            <span v-else>内容公告</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createDate" width="150" label="创建时间" :formatter="formatterTime"></el-table-column>
                    <el-table-column prop="startDate" width="150" label="开始展示时间"></el-table-column>
                    <el-table-column prop="endDate" width="150" label="结束展示时间"></el-table-column>
                    <el-table-column prop="channels" width="150" label="生效渠道列表"></el-table-column>
                    <el-table-column prop="top" width="100" label="置顶"></el-table-column>
                    <el-table-column prop="popupTips" width="80" label="强弹"></el-table-column>
                    <el-table-column prop="dotTips" width="80" label="红点提示"></el-table-column>
                    <el-table-column width="150" label="红点提示时间">
                        <template slot-scope="scope">
                            <span>{{Utils.formatDate(new Date(scope.row.dotTipsTime))}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label='操作'>
                        <template slot-scope="scope">
                            <el-button type="text" @click="editContent(scope.row)">编辑</el-button>
                            <el-button type="text" @click="moveToDraft(scope.row)">移至草稿箱</el-button>
                            <el-button type="text" @click="copyContent(scope.row)">复制</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination @current-change="handleCurrentChange" :current-page="currentPage"
                                   :page-size="pageSize"
                                   layout="total, prev, pager, next, jumper" :total="totalRow">
                    </el-pagination>
                </div>
            </el-tab-pane>
            <el-tab-pane label="草稿箱" name="second">
                <el-table :data="dataHandled" border>
                    <el-table-column prop="lang" width="150px" label="公告语言">
                        <template slot-scope="scope">
                            <span v-for="item in noticeLangOptions" v-if="item.value==scope.row.lang">{{item.label}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="title" width="150" label="公告标题"></el-table-column>
                    <el-table-column prop="createDate" width="150" label="创建时间" :formatter="formatterTime"></el-table-column>
                    <el-table-column prop="startDate" width="150" label="开始展示时间"></el-table-column>
                    <el-table-column prop="endDate" width="150" label="结束展示时间"></el-table-column>
                    <el-table-column prop="channels" width="150" label="生效渠道列表"></el-table-column>
                    <el-table-column prop="top" width="100" label="置顶"></el-table-column>
                    <el-table-column prop="dotTips" width="100" label="红点提示"></el-table-column>
                    <el-table-column width="150" label="红点提示时间">
                        <template slot-scope="scope">
                            <span>{{Utils.formatDate(new Date(scope.row.dotTipsTime))}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="content" label="公告内容">
                        <template slot-scope="scope">
                            <!--<span v-html="scope.row.content"></span>-->
                            <span>{{JSON.stringify(scope.row.content).slice(0,50) + (JSON.stringify(scope.row.content).length > 50?"...":"")}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label='操作'>
                        <template slot-scope="scope">
                            <el-button type="text" @click="sendNotice(scope.row)">查看与发送</el-button>
                            <el-button type="text" @click="noticeDelete(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination @current-change="handleCurrentChange" :current-page="currentPage"
                                   :page-size="pageSize"
                                   layout="total, prev, pager, next, jumper" :total="totalRow">
                    </el-pagination>
                </div>
            </el-tab-pane>
        </el-tabs>

        <el-dialog title='轮播图设置' :visible.sync="uploadBannerShow" width="50%" lock-scroll center>
            <div>
                <el-form label-position="left" label-width="50px">
                    <el-form-item label="链接:">
                        <el-input v-model="uploadBannerLink"></el-input>
                    </el-form-item>

                    <el-form-item label="上传:">
                        <el-upload
                            class="avatar-uploader"
                            :action="uploadBannerUrl"
                            :show-file-list="false"
                            :before-upload="beforeBannerUpload"
                            :on-success="handleBannerSuccess">
                            <img v-if="bannerUrl" :src="bannerUrl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <div class="avatar-limit">限制width=985,height=124，图片格式为png</div>
                    </el-form-item>

                    <el-form-item label="列表:">
                        <div class="notice-png-list" v-for="(item,index) in noticePngData" :key="index">
                            <div style="padding-right: 10px;">{{index+1}}:</div>
                            <img :src="noticePngPrefix + item.png" class="avatar">
                            <!--<el-upload-->
                            <!--class="avatar-uploader"-->
                            <!--:action="uploadBannerUrl"-->
                            <!--:show-file-list="false"-->
                            <!--:before-upload="beforeBannerUpload"-->
                            <!--:on-success="updateBannerSuccess">-->
                            <!--<img :src="noticePngPrefix + item.png" class="avatar">-->
                            <!--</el-upload>-->
                            <div style="padding: 0 10px;">
                                <el-input v-model="item.link">
                                    <el-button slot="append" icon="el-icon-check" @click="changeNoticePng"></el-button>
                                </el-input>
                            </div>
                            <div style="display: flex;justify-content: space-between;width: 16%;">
                                <el-button type="primary" icon="el-icon-top" circle @click="upNoticePng(index)"></el-button>
                                <el-button type="primary" icon="el-icon-bottom" circle @click="downNoticePng(index)"></el-button>
                                <el-button type="danger" icon="el-icon-delete" circle @click="delNoticePng(index)"></el-button>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>

        <el-dialog title='编辑' :visible.sync="editContentShow" width="50%" lock-scroll center>
            <div>
                <el-form label-position="right" label-width="100px">
                    <el-form-item label="语言">
                        <el-select v-model="editContentData.lang">
                            <el-option
                                v-for="item in noticeLangOptions"
                                :key="item.value"
                                :value="item.value"
                                :label="item.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="标题:">
                        <el-input v-model="editContentData.title" placeholder="请输入标题"></el-input>
                    </el-form-item>
                    <el-form-item label="内容:" v-if="editContentData.type !== 'picContent'">
                        <quill-editor class="editor-quill" ref="myEditQuillEditor" v-model="noticeEditContent" @change="onEditorEditChange($event)" :options="editorOption"/>
                    </el-form-item>

                    <el-form-item label="图片链接" v-if="editContentData.type === 'picContent'">
                        <el-input v-model="editContentData.contentLink" :min="1" :max="999"></el-input>
                    </el-form-item>

                    <el-form-item label="跳转模式" v-if="editContentData.type === 'picContent'">
                        <el-input v-model="editContentData.jumpMode" :min="1" :max="999"></el-input>
                        <div class="notice-top-tip">默认为0;(1-游戏模块，0-外链)</div>
                    </el-form-item>

                    <el-form-item label="跳转链接" v-if="editContentData.type === 'picContent'">
                        <el-input v-model="editContentData.jumpLink" :min="1" :max="999"></el-input>
                    </el-form-item>

                    <el-form-item label="时区：">
                        <el-select v-model="localZoneTime3">
                            <el-option
                                v-for="localZoneTimeItem in localZoneTimeOptions"
                                :key="localZoneTimeItem.value"
                                :value="localZoneTimeItem.value"
                                :label="localZoneTimeItem.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="时间:">
                        <el-date-picker v-model="localEditContentDataDate" @change="getEditContentDataDate" type="datetimerange" range-separator='至'
                                        start-placeholder='开始时间' end-placeholder='结束时间' value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="本地时间:" v-if="editContentDataDate">
                        <span class="notice-top-tip">{{localEditContentDataDate2[0]}}</span>
                        <span>至</span>
                        <span class="notice-top-tip">{{localEditContentDataDate2[1]}}</span>
                        <span class="notice-top-tip">(utc{{localZoneTime3}})</span>
                    </el-form-item>
                    <el-form-item label="服务器时间:" v-if="editContentDataDate">
                        <span class="notice-top-tip">{{editContentDataDate[0]}}</span>
                        <span>至</span>
                        <span class="notice-top-tip">{{editContentDataDate[1]}}</span>
                        <span class="notice-top-tip">(utc{{serverZoneTime}})</span>
                    </el-form-item>
                    <el-form-item label="置顶:">
                        <el-input-number v-model="editContentData.top" :min="1" :max="999"></el-input-number>
                        <div class="notice-top-tip">默认为1,数值范围是1~999,数值越大越前</div>
                    </el-form-item>

                    <el-form-item label="红点">
                        <el-input v-model="editContentData.dotTips" :min="1" :max="999"></el-input>
                        <div class="notice-top-tip">默认为0;(1-红点提示，0-不提示)</div>
                    </el-form-item>
                    <el-form-item label="强弹">
                        <el-input v-model="editContentData.popupTips" :min="1" :max="999"></el-input>
                        <div class="notice-top-tip">默认为0;(1-强弹，0-不强弹)</div>
                    </el-form-item>
                    <el-form-item label="是否生效:">
                        <el-switch v-model="editContentData.effective" active-text="是" inactive-text="否"></el-switch>
                    </el-form-item>
                    <el-form-item label="玩家渠道开关">
                        <el-switch
                            v-model="channelListSwitch"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="自选"
                            inactive-text="全选"
                            :active-value="true"
                            :inactive-value="false">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="玩家渠道" v-if="channelListSwitch">
                        <el-select v-model="editContentData.channelList" multiple>
                            <el-option
                                v-for="item in channelData"
                                :key="item.value"
                                :value="item.value.toString()"
                                :label="item.value + '(' + item.channel + ')'">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="媒体值开关">
                        <el-switch
                            v-model="mediaSwitch"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="自选"
                            inactive-text="全选"
                            :active-value="true"
                            :inactive-value="false">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="媒体值" v-if="mediaSwitch">
                        <el-select v-model="editContentData.medias" multiple allow-create filterable default-first-option>
                            <el-option
                                v-for="item in mediaData"
                                :key="item.value"
                                :value="item.value.toString()"
                                :label="item.value + '(' + item.media + ')'">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editContentShow = false">取消</el-button>
                <el-button type="primary" @click="noticeEdit">确定</el-button>
            </div>
        </el-dialog>

        <el-dialog title='创建' :visible.sync="createNoticeShow" width="50%" lock-scroll center>
            <div>
                <el-form label-position="right" label-width="100px" label-suffix=":">
                    <el-form-item label="语言">
                        <el-select v-model="noticeForm.lang">
                            <el-option
                                v-for="item in noticeLangOptions"
                                :key="item.value"
                                :value="item.value"
                                :label="item.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="标题">
                        <el-input v-model="noticeForm.title" placeholder="请输入标题"></el-input>
                    </el-form-item>

                    <el-form-item label="内容模式">
                        <el-switch
                            v-model="noticeForm.contentSwitch"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="内容公告"
                            inactive-text="图片公告"
                            :active-value="true"
                            :inactive-value="false">
                        </el-switch>
                    </el-form-item>

                    <el-form-item label="内容" v-if="noticeForm.contentSwitch">
                        <quill-editor class="editor-quill" ref="quill" v-model="noticeSendContent" @change="onEditorChange($event)" :options="editorOption"/>
                    </el-form-item>

                    <el-form-item label="图片链接" v-if="!noticeForm.contentSwitch">
                        <el-input v-model="noticeForm.contentLink" :min="1" :max="999"></el-input>
                    </el-form-item>

                    <el-form-item label="跳转模式" v-if="!noticeForm.contentSwitch">
                        <el-input v-model="noticeForm.jumpMode" :min="1" :max="999"></el-input>
                        <div class="notice-top-tip">默认为0;(1-游戏模块，0-外链)</div>
                    </el-form-item>

                    <el-form-item label="跳转链接" v-if="!noticeForm.contentSwitch">
                        <el-input v-model="noticeForm.jumpLink" :min="1" :max="999"></el-input>
                    </el-form-item>

                    <el-form-item label="时区：">
                        <el-select v-model="localZoneTime2">
                            <el-option
                                v-for="localZoneTimeItem in localZoneTimeOptions"
                                :key="localZoneTimeItem.value"
                                :value="localZoneTimeItem.value"
                                :label="localZoneTimeItem.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="时间">
                        <el-date-picker v-model="localDateTime" type="datetimerange" @change="getCreateNoticeContentDataDate" range-separator='至'
                                        start-placeholder='开始时间' end-placeholder='结束时间' value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="本地时间:" v-if="dateTime">
                        <span class="notice-top-tip">{{localDateTime2[0]}}</span>
                        <span>至</span>
                        <span class="notice-top-tip">{{localDateTime2[1]}}</span>
                        <span class="notice-top-tip">(utc{{localZoneTime2}})</span>
                    </el-form-item>
                    <el-form-item label="服务器时间:" v-if="dateTime">
                        <span class="notice-top-tip">{{dateTime[0]}}</span>
                        <span>至</span>
                        <span class="notice-top-tip">{{dateTime[1]}}</span>
                        <span class="notice-top-tip">(utc{{serverZoneTime}})</span>
                    </el-form-item>
                    <el-form-item label="置顶">
                        <el-input-number v-model="noticeForm.top" :min="1" :max="999"></el-input-number>
                        <div class="notice-top-tip">默认为1,数值范围是1~999,数值越大越前</div>
                    </el-form-item>
                    <el-form-item label="红点">
                        <el-input v-model="noticeForm.dotTips" :min="1" :max="999"></el-input>
                        <div class="notice-top-tip">默认为0;(1-红点提示，0-不提示)</div>
                    </el-form-item>
                    <el-form-item label="强弹">
                        <el-input v-model="noticeForm.popupTips" :min="1" :max="999"></el-input>
                        <div class="notice-top-tip">默认为0;(1-强弹，0-不强弹)</div>
                    </el-form-item>
                    <el-form-item label="是否生效">
                        <el-switch v-model="noticeForm.effective" active-text="生效列表" inactive-text="草稿箱"></el-switch>
                    </el-form-item>

                    <el-form-item label="玩家渠道开关">
                        <el-switch
                            v-model="channelListSwitch"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="自选"
                            inactive-text="全选"
                            :active-value="true"
                            :inactive-value="false">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="玩家渠道" v-if="channelListSwitch">
                        <el-select v-model="noticeForm.channelList" multiple>
                            <el-option
                                v-for="item in channelData"
                                :key="item.value"
                                :value="item.value.toString()"
                                :label="item.value + '(' + item.channel + ')'">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="媒体值开关">
                        <el-switch
                            v-model="mediaSwitch"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="自选"
                            inactive-text="全选"
                            :active-value="true"
                            :inactive-value="false">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="媒体值" v-if="mediaSwitch">
                        <el-select v-model="noticeForm.medias" multiple allow-create filterable default-first-option>
                            <el-option
                                v-for="item in mediaData"
                                :key="item.value"
                                :value="item.value.toString()"
                                :label="item.value + '(' + item.media + ')'">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>

            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="createNoticeShow = false">取消</el-button>
                <el-button type="primary" @click="noticeSend">确定</el-button>
            </div>
        </el-dialog>

        <el-dialog title='发送公告' :visible.sync="sendNoticeShow" width="50%" lock-scroll center>
            <div>
                <el-form label-position="right" label-width="100px">
                    <el-form-item label="语言">
                        <el-select v-model="sendNoticeContentData.lang">
                            <el-option
                                v-for="item in noticeLangOptions"
                                :key="item.value"
                                :value="item.value"
                                :label="item.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="标题:">
                        <el-input v-model="sendNoticeContentData.title" placeholder="请输入标题"></el-input>
                    </el-form-item>
                    <el-form-item label="内容:" v-if="sendNoticeContentData.type !== 'picContent'">
                        <quill-editor class="editor-quill" ref="mySendQuillEditor" v-model="sendConfirmNoticeContent" @change="onEditorSendChange($event)" :options="editorOption"/>
                    </el-form-item>

                    <el-form-item label="图片链接" v-if="sendNoticeContentData.type === 'picContent'">
                        <el-input v-model="sendNoticeContentData.contentLink" :min="1" :max="999"></el-input>
                    </el-form-item>

                    <el-form-item label="跳转模式" v-if="sendNoticeContentData.type === 'picContent'">
                        <el-input v-model="sendNoticeContentData.jumpMode" :min="1" :max="999"></el-input>
                        <div class="notice-top-tip">默认为0;(1-游戏模块，0-外链)</div>
                    </el-form-item>

                    <el-form-item label="跳转链接" v-if="sendNoticeContentData.type === 'picContent'">
                        <el-input v-model="sendNoticeContentData.jumpLink" :min="1" :max="999"></el-input>
                    </el-form-item>

                    <el-form-item label="时区：">
                        <el-select v-model="localZoneTime">
                            <el-option
                                v-for="localZoneTimeItem in localZoneTimeOptions"
                                :key="localZoneTimeItem.value"
                                :value="localZoneTimeItem.value"
                                :label="localZoneTimeItem.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="时间:">
                        <el-date-picker v-model="localSendNoticeContentDataDate" @change="getSendNoticeContentDataDate" type="datetimerange" range-separator='至'
                                        start-placeholder='开始时间' end-placeholder='结束时间' value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="本地时间:" v-if="sendNoticeContentDataDate">
                        <span class="notice-top-tip">{{localSendNoticeContentDataDate2[0]}}</span>
                        <span>至</span>
                        <span class="notice-top-tip">{{localSendNoticeContentDataDate2[1]}}</span>
                        <span class="notice-top-tip">(utc{{localZoneTime}})</span>
                    </el-form-item>
                    <el-form-item label="服务器时间:" v-if="sendNoticeContentDataDate">
                        <span class="notice-top-tip">{{sendNoticeContentDataDate[0]}}</span>
                        <span>至</span>
                        <span class="notice-top-tip">{{sendNoticeContentDataDate[1]}}</span>
                        <span class="notice-top-tip">(utc{{serverZoneTime}})</span>
                    </el-form-item>
                    <el-form-item label="置顶:">
                        <el-input-number v-model="sendNoticeContentData.top" :min="1" :max="999"></el-input-number>
                        <div class="notice-top-tip">默认为1,数值范围是1~999,数值越大越前</div>
                    </el-form-item>
                    <el-form-item label="红点">
                        <el-input v-model="sendNoticeContentData.dotTips" :min="1" :max="999"></el-input>
                        <div class="notice-top-tip">默认为0;(1-红点提示，0-不提示)</div>
                    </el-form-item>
                    <el-form-item label="强弹">
                        <el-input v-model="sendNoticeContentData.popupTips" :min="1" :max="999"></el-input>
                        <div class="notice-top-tip">默认为0;(1-强弹，0-不强弹)</div>
                    </el-form-item>
                    <el-form-item label="是否生效:">
                        <span>{{sendNoticeContentData.effective?'是': '否'}}</span>
                    </el-form-item>
                    <el-form-item label="玩家渠道开关">
                        <el-switch
                            v-model="channelListSwitch"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="自选"
                            inactive-text="全选"
                            :active-value="true"
                            :inactive-value="false">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="玩家渠道" v-if="channelListSwitch">
                        <el-select v-model="sendNoticeContentData.channelList" multiple>
                            <el-option
                                v-for="item in channelData"
                                :key="item.value"
                                :value="item.value.toString()"
                                :label="item.value + '(' + item.channel + ')'">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="媒体值开关">
                        <el-switch
                            v-model="mediaSwitch"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="自选"
                            inactive-text="全选"
                            :active-value="true"
                            :inactive-value="false">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="媒体值" v-if="mediaSwitch">
                        <el-select v-model="sendNoticeContentData.medias" multiple allow-create filterable default-first-option>
                            <el-option
                                v-for="item in mediaData"
                                :key="item.value"
                                :value="item.value.toString()"
                                :label="item.value + '(' + item.media + ')'">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="sendNoticeShow = false">取消</el-button>
                <el-button type="primary" @click="noticeSendConfirm">确定</el-button>
            </div>
        </el-dialog>
    </el-card>
</template>

<script>
    import noticeApi from '../../service/notice_api'
    import configSettingApi from '../../service/config_setting_api'
    import loginApi from '../../service/login_api'
    import {
        mapState
    } from 'vuex';
    import paginationController from '../../mixins/pagination'
    import actionConfirm from '../../mixins/action_confirm'
    import Utils from '../../lib/utils'
    import { apis } from '../../lib/apis'
    import commonApi from "../../service/common_api";
    import gameApi from "../../service/game_api";
    import activityApi from "../../service/activity_api";

    export default {
        name: "notice_manager",
        data() {
            return {
                serverZoneTime: Global_Config_Yunwei.serverZoneTime,
                activeName: 'first',
                Utils: Utils,
                localZoneTime: 8,
                localZoneTime2: 8,
                localZoneTime3: 8,
                localZoneTimeOptions: [
                    {
                        label: 'utc8',
                        value: 8
                    },
                    {
                        label: 'utc-5',
                        value: -5
                    }
                ],
                content:'',
                editContentShow: false,
                editContentData: {},
                editContentDataDate: '',
                localEditContentDataDate: '',
                localEditContentDataDate2: '',
                noticeEditContent: '',
                noticeEditContentData: [],

                createNoticeShow: false,
                noticeForm: {
                    type: '',
                    title: '',
                    content: [],
                    startDate: '',
                    endDate: '',
                    channelList: [],
                    top: 1,
                    effective: false,
                    loginUri: '',
                    medias: '',
                    contentSwitch:true,
                    dotTips:'0',
                    popupTips:'0',
                    contentLink:'',
                    jumpMode:'0',
                    jumpLink:'',
                    lang: ''
                },
                noticeSendContent: '',
                noticeSendContentData: [],

                dateTime: '',
                localDateTime: '',
                localDateTime2: '',

                loginUriStr: '',
                // 发送公告
                sendNoticeShow: false,
                sendNoticeContentData: {},
                sendNoticeContentDataDate: '',
                localSendNoticeContentDataDate: '',
                localSendNoticeContentDataDate2: '',
                sendConfirmNoticeContent: '',
                sendConfirmNoticeContentData: [],

                // 发送内容选中数据
                selectedSendContent: [],

                formInline:{
                    contentFileList: ''
                },
                editorOption: {
                    modules: {
                        toolbar: {
                            container: [
                                // ['blockquote', 'code-block'],// 引用  代码块
                                // [{'direction': 'rtl'}],// 文本方向
                                // ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
                                ['bold', 'underline'], // 加粗 斜体 下划线 删除线
                                // [{ header: 1 }, { header: 2 }], // 1、2 级标题
                                // [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
                                // [{ script: 'sub' }, { script: 'super' }], // 上标/下标
                                // [{ indent: '-1' }, { indent: '+1' }], // 缩进
                                // [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
                                // [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
                                // [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
                                [{ color: ["#ffffff", "#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466", '#ffc437', '#a6bddd'] }], // 字体颜色、字体背景颜色
                                // [{ font: [] }], // 字体种类
                                // [{ align: [] }], // 对齐方式
                                // ['clean'], // 清除文本格式
                                // ['link', 'image', 'video'] // 链接,图片,视频
                                ['link'] // 链接,图片,视频
                            ],
                            handlers: {
                                image: function(value) {
                                    if (value) {
                                        document.querySelector('#upload').click()  // 劫持原来的图片点击按钮事件
                                    } else {
                                        this.quill.format('image', false)
                                    }
                                }
                            }
                        }
                    }
                },

                uploadBannerShow: false,
                uploadBannerUrl: apis.notice_banner_upload,
                uploadBannerLink: '',
                uploadBannerIndex: '',
                bannerUrl: '',
                noticePngData: [],
                // 公告图前缀
                noticePngPrefix: '',

                // 渠道数据
                channelData: [],
                // 媒体值列表
                mediaData: [],

                // 渠道开关
                channelListSwitch: false,
                // 媒体值开关
                mediaSwitch: false,

                loginInfoGame:[],
                loginInfoWorld:[],

                yunweiLoginList:[],
                resultShow:false,
                resultArray:[],
                noticeLangOptions: [
                    {
                        value: 'zh-Hans',
                        label: '简体中文'
                    },
                    {
                        value: 'zh-Hant',
                        label: '中文繁体'
                    },
                    {
                        value: 'ru-RU',
                        label: '俄语'
                    },
                    {
                        value: 'ko-KR',
                        label: '韩语'
                    },
                    {
                        value: 'ja-JP',
                        label: '日语'
                    },
                    {
                        value: 'en-US',
                        label: '英语'
                    },
                ]

            }
        },
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken
            }),
        },
        mounted() {
            this.getNoticeData();
            this.loadNoticeInfo();
            this.noticeInfo();
            this.getChannelsList();
            this.getMediasList();
        },
        mixins: [paginationController, actionConfirm],
        methods: {
            getSendNoticeContentDataDate() {
                let self = this;
                const date = self.localSendNoticeContentDataDate;

                let localTime = '';
                let localTimeZone = self.localZoneTime;

                localTime = date;
                self.localSendNoticeContentDataDate2 = localTime;

                let time = [];
                let timeZone = self.serverZoneTime;

                if (localTimeZone == -5) {
                    if (timeZone == -5) {
                        time[0] = localTime[0];
                        time[1] = localTime[1];
                    } else if (timeZone == 8) {
                        time[0] = Utils.formatDate(self.west5TimeToEast8Time(new Date(date[0])));
                        time[1] = Utils.formatDate(self.west5TimeToEast8Time(new Date(date[1])));
                    }
                } else if (localTimeZone == 8) {
                    if (timeZone == -5) {
                        time[0] = Utils.formatDate(self.toWest5Time(new Date(date[0])));
                        time[1] = Utils.formatDate(self.toWest5Time(new Date(date[1])));
                    } else if (timeZone == 8) {
                        time[0] = localTime[0];
                        time[1] = localTime[1];
                    }
                }

                self.sendNoticeContentDataDate = time;
            },

            getCreateNoticeContentDataDate() {
                let self = this;
                const date = self.localDateTime;
                let localTime = '';
                let localTimeZone = self.localZoneTime2;

                localTime = date;
                self.localDateTime2 = localTime;

                let time = [];
                let timeZone = self.serverZoneTime;

                if (localTimeZone == -5) {
                    if (timeZone == -5) {
                        time[0] = localTime[0];
                        time[1] = localTime[1];
                    } else if (timeZone == 8) {
                        time[0] = Utils.formatDate(self.west5TimeToEast8Time(new Date(date[0])));
                        time[1] = Utils.formatDate(self.west5TimeToEast8Time(new Date(date[1])));
                    }
                } else if (localTimeZone == 8) {
                    if (timeZone == -5) {
                        time[0] = Utils.formatDate(self.toWest5Time(new Date(date[0])));
                        time[1] = Utils.formatDate(self.toWest5Time(new Date(date[1])));
                    } else if (timeZone == 8) {
                        time[0] = localTime[0];
                        time[1] = localTime[1];
                    }
                }

                self.dateTime = time;
            },

            getEditContentDataDate() {
                let self = this;
                const date = self.localEditContentDataDate;
                let localTime = '';
                let localTimeZone = self.localZoneTime3;

                localTime = date;
                self.localEditContentDataDate2 = localTime;

                let time = [];
                let timeZone = self.serverZoneTime;

                if (localTimeZone == -5) {
                    if (timeZone == -5) {
                        time[0] = localTime[0];
                        time[1] = localTime[1];
                    } else if (timeZone == 8) {
                        time[0] = Utils.formatDate(self.west5TimeToEast8Time(new Date(date[0])));
                        time[1] = Utils.formatDate(self.west5TimeToEast8Time(new Date(date[1])));
                    }
                } else if (localTimeZone == 8) {
                    if (timeZone == -5) {
                        time[0] = Utils.formatDate(self.toWest5Time(new Date(date[0])));
                        time[1] = Utils.formatDate(self.toWest5Time(new Date(date[1])));
                    } else if (timeZone == 8) {
                        time[0] = localTime[0];
                        time[1] = localTime[1];
                    }
                }

                self.editContentDataDate = time;
            },

            noticeTabClick(tab,event) {
                this.getNoticeData();
            },

            loadNoticeInfo() {
                let self = this;
                commonApi.getConfs({
                    tables: 'yunwei_server_config,login_configuration,login_info_game,login_info_world'
                }).then(res => {
                    let sourceGameInfo = res.login_info_game;
                    this.loginInfoGame = [];
                    let subGameInfo = [];
                    for (let tmpItem of sourceGameInfo) {
                        if ('0' === tmpItem.combine_server_number) {
                            //0为主服
                            tmpItem.children = [];
                            this.loginInfoGame.push(tmpItem);
                        } else {
                            subGameInfo.push(tmpItem);
                        }
                    }

                    for (let tmpItem of subGameInfo) {
                        this.loginInfoGame.forEach(mainGameServer => {
                            if (tmpItem.combine_server_number === mainGameServer.server_number) {
                                mainGameServer.children.push(tmpItem);
                            }
                        })
                    }

                    let sourceWorldInfo = res.login_info_world;
                    this.loginInfoWorld = [];
                    let subWorldInfo = [];
                    for (let tmpItem of sourceWorldInfo) {
                        tmpItem.server_maintenance = -1;
                        if ('0' === tmpItem.combine_server_number) {
                            //0为主服
                            tmpItem.children = [];
                            this.loginInfoWorld.push(tmpItem);
                        } else {
                            subWorldInfo.push(tmpItem);
                        }
                    }

                    for (let tmpItem of subWorldInfo) {
                        this.loginInfoWorld.forEach(mainServer => {
                            if (tmpItem.combine_server_number === mainServer.server_number) {
                                mainServer.children.push(tmpItem);
                            }
                        })
                    }

                    self.yunweiLoginList = [];
                    res.yunwei_server_config.forEach(item => {
                        if (item.server_type == 'login') {
                            self.yunweiLoginList.push(item);
                        }
                    })

                    res.login_configuration.forEach(item => {
                        // 公告轮播图
                        if (item.id == '107') {
                            this.noticePngData = JSON.parse(item.key_value);

                            for (var i in this.noticePngData) {
                                if (this.noticePngData[i] == null) {
                                    this.noticePngData.splice(i,1);
                                }
                            }
                        }
                    })
                })
            },
            // 公告列表
            getNoticeData() {
                noticeApi.noticeList({
                    token: this.token
                }).then(res => {
                    if (this.activeName == 'first') {
                        this.rawData = res.effectiveNotices;
                        this.totalRow = res.effectiveNotices.length;
                    } else {
                        this.rawData = res.draftNotices;
                        this.totalRow = res.draftNotices.length;
                    }
                });
            },

            dotTipsPush(){
                let self = this;
                this.$confirm("此操作会给在线玩家一个公告红点提示", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    self.resultShow = true;
                    self.resultArray = [];
                    self.loginInfoGame.forEach(reloadGameInfo => {
                        let balanceIpRecord = reloadGameInfo.inner_urls.split(';')[0];
                        self.resultArray.push({
                            server_url: balanceIpRecord,
                            server_name: reloadGameInfo.server_name,
                            resStatus: '0'
                        });
                        let dotPushForm = {
                            uri: balanceIpRecord,
                            hintId: 130,
                            record: '1'
                        }
                        gameApi.dotTipsPush({
                            token: self.token,
                            dotPushForm: dotPushForm
                        }).then(res => {
                            self.resultArray.forEach(resultItem => {
                                if (resultItem.server_url == dotPushForm.uri) {
                                    resultItem.resStatus = res.resStatus
                                }
                            })
                        })

                    })
                });
            },

            formatterTime(row) {
                var createDate = row.createDate;
                createDate = Utils.formatDate(createDate);
                return createDate;
            },

            editContent(e) {
                this.editContentShow = true;
                this.editContentData = e;
                this.editContentDataDate = [e.startDate, e.endDate];

                if (this.editContentData.channelList.length == 1 && this.editContentData.channelList[0]== '0') {
                    this.channelListSwitch = false;
                } else {
                    this.channelListSwitch = true;
                }

                if (this.editContentData.medias == '0') {
                    this.mediaSwitch = false;
                } else {
                    this.mediaSwitch = true;
                    this.editContentData.medias = this.editContentData.medias.split(',');
                }

                var contentJsonData = JSON.parse(e.contentJson);
                this.noticeEditContentData = [];
                contentJsonData.forEach(item => {
                    if (item.hyperlink!==undefined) {
                        this.noticeEditContentData.push({
                            insert: item.string,
                            attributes: {
                                color: item.face.color,
                                bold: (item.face.dilate == '0.55')?true:false,
                                link: item.hyperlink,
                                underline: item.u
                            }
                        })
                    } else {
                        this.noticeEditContentData.push({
                            insert: item.string,
                            attributes: {
                                color: item.face.color,
                                bold: (item.face.dilate == '0.55')?true:false,
                                underline: item.u
                            }
                        })
                    }
                })
                this.$nextTick(() => {
                    var quill = this.$refs.myEditQuillEditor.quill;
                    quill.setContents(this.noticeEditContentData)
                })

            },

            sendNotice(e) {
                this.sendNoticeShow = true;
                this.sendNoticeContentData = e;
                this.sendNoticeContentData.effective = true;
                this.sendNoticeContentDataDate = [e.startDate, e.endDate];

                if (this.sendNoticeContentData.channelList.length == 1 && this.sendNoticeContentData.channelList[0]== '0') {
                    this.channelListSwitch = false;
                } else {
                    this.channelListSwitch = true;
                }

                if (this.sendNoticeContentData.medias == '0') {
                    this.mediaSwitch = false;
                } else {
                    this.mediaSwitch = true;
                    this.sendNoticeContentData.medias = this.sendNoticeContentData.medias.split(',');
                }

                var contentJsonData = JSON.parse(e.contentJson);
                this.sendConfirmNoticeContentData = [];
                contentJsonData.forEach(item => {
                    if (item.hyperlink!==undefined) {
                        this.sendConfirmNoticeContentData.push({
                            insert: item.string,
                            attributes: {
                                color: item.face.color,
                                bold: (item.face.dilate == '0.55')?true:false,
                                link: item.hyperlink,
                                underline: item.u
                            }
                        })
                    } else {
                        this.sendConfirmNoticeContentData.push({
                            insert: item.string,
                            attributes: {
                                color: item.face.color,
                                bold: (item.face.dilate == '0.55')?true:false,
                                underline: item.u
                            }
                        })
                    }
                })
                this.$nextTick(() => {
                    var quill = this.$refs.mySendQuillEditor.quill;
                    quill.setContents(this.sendConfirmNoticeContentData)
                })
            },

            showCreateNotice() {
                this.createNoticeShow = true;
                this.noticeSendContent = '';
                this.noticeSendContentData = [];
                this.noticeForm.title = '';
                this.noticeForm.content = [];
                this.noticeForm.channelList = [];
                this.noticeForm.medias = '';
                this.noticeForm.top = 1;
                this.noticeForm.effective = false;
                this.noticeForm.startDate = '';
                this.noticeForm.dotTips = '0';
                this.noticeForm.endDate = '';
                this.noticeForm.popupTips = '0';
                this.noticeForm.contentLink = '';
                this.noticeForm.jumpMode = '0';
                this.noticeForm.jumpLink = '';
                this.noticeForm.contentSwitch = true;
                this.dateTime = '';
                this.channelListSwitch = false;
                this.mediaSwitch = false;
            },

            // 创建公告
            noticeSend() {
                var data = this.noticeForm;
                // data.loginUri = this.loginUriStr;
                data.startDate = this.dateTime[0];
                data.endDate = this.dateTime[1];
                // if (data.title.length > 8) {
                //     this.$message({
                //         type: 'warning',
                //         message: '标题超过8个字'
                //     });
                //     return;
                // }

                if (!data.contentSwitch){
                    data.type = "picContent";
                }

                if (data.startDate == undefined || data.endDate == undefined) {
                    this.$message({
                        type: 'warning',
                        message: '未填写时间'
                    });
                    return;
                }

                data.content = this.noticeSendContentData;

                var channelList = '';
                if (!this.channelListSwitch) {
                    channelList = ['0'];
                } else {
                    channelList = data.channelList;
                }

                var medias = '';
                if (!this.mediaSwitch) {
                    medias = '0';
                } else {
                    for (var i in data.medias) {
                        data.medias[i] = data.medias[i].split('(')[0];
                    }
                    medias = data.medias.join(',');
                }

                noticeApi.noticeSend({
                    token: this.token,
                    noticeForm: {
                        type: data.type,
                        title: data.title,
                        content: data.content,
                        startDate: data.startDate,
                        endDate: data.endDate,
                        channelList: channelList,
                        top: data.top,
                        effective: data.effective,
                        medias: medias,
                        dotTips: data.dotTips,
                        popupTips: data.popupTips,
                        jumpLink: data.jumpLink,
                        jumpMode: data.jumpMode,
                        contentLink: data.contentLink,
                        lang: data.lang
                    },
                }).then(res => {
                    if (data.effective) {
                        this.reloadAxiosAll(false,'NoticeConfig');
                    }
                    this.$message({
                        type: 'success',
                        message: '创建成功!'
                    })
                    this.createNoticeShow = false;
                    this.getNoticeData();
                })
            },

            // 删除公告
            noticeDelete(id) {
                noticeApi.noticeDelete({
                    token: this.token,
                    noticeForm: {
                        id: id,
                        effective: '',
                    },
                }).then(res => {
                    this.reloadAxiosAll(false,'NoticeConfig');
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    })
                    this.getNoticeData();
                })

            },

            // 编辑公告
            noticeEdit() {
                var data = this.editContentData;
                // data.loginUri = this.loginUriStr;
                data.startDate = this.editContentDataDate[0];
                data.endDate = this.editContentDataDate[1];

                // if (data.title.length > 8) {
                //     this.$message({
                //         type: 'warning',
                //         message: '标题超过8个字'
                //     });
                //     return;
                // }

                if (data.startDate == undefined || data.endDate == undefined) {
                    this.$message({
                        type: 'warning',
                        message: '未填写时间'
                    });
                    return;
                }

                data.content = this.noticeEditContentData;

                var channelList = '';
                if (!this.channelListSwitch) {
                    channelList = ['0'];
                } else {
                    channelList = data.channelList;
                }

                var medias = '';
                if (!this.mediaSwitch) {
                    medias = '0';
                } else {
                    for (var i in data.medias) {
                        data.medias[i] = data.medias[i].split('(')[0];
                    }
                    medias = data.medias.join(',');
                }

                noticeApi.noticeEdit({
                    token: this.token,
                    noticeForm: {
                        id: data.id,
                        type: data.type,
                        title: data.title,
                        content: data.content,
                        startDate: data.startDate,
                        endDate: data.endDate,
                        channelList: channelList,
                        top: data.top,
                        effective: data.effective,
                        medias: medias,
                        popupTips: data.popupTips,
                        dotTips: data.dotTips,
                        jumpLink: data.jumpLink,
                        jumpMode: data.jumpMode,
                        contentLink: data.contentLink,
                        lang: data.lang
                    }
                }).then(res => {
                    if (data.effective) {
                        this.reloadAxiosAll(false,'NoticeConfig');
                    }
                    this.$message({
                        type: 'success',
                        message: '修改成功!'
                    })
                    this.editContentShow = false;
                    this.getNoticeData();
                })

            },


            // 草稿箱发送公告
            noticeSendConfirm() {
                var data = this.sendNoticeContentData;
                // data.loginUri = this.loginUriStr;
                data.startDate = this.sendNoticeContentDataDate[0];
                data.endDate = this.sendNoticeContentDataDate[1];

                // if (data.title.length > 8) {
                //     this.$message({
                //         type: 'warning',
                //         message: '标题超过8个字'
                //     });
                //     return;
                // }

                if (data.startDate == undefined || data.endDate == undefined) {
                    this.$message({
                        type: 'warning',
                        message: '未填写时间'
                    });
                    return;
                }

                data.content = this.sendConfirmNoticeContentData;

                var channelList = '';
                if (!this.channelListSwitch) {
                    channelList = ['0'];
                } else {
                    channelList = data.channelList;
                }

                var medias = '';
                if (!this.mediaSwitch) {
                    medias = '0';
                } else {
                    for (var i in data.medias) {
                        data.medias[i] = data.medias[i].split('(')[0];
                    }
                    medias = data.medias.join(',');
                }

                noticeApi.noticeEdit({
                    token: this.token,
                    noticeForm: {
                        id: data.id,
                        type: data.type,
                        title: data.title,
                        content: data.content,
                        startDate: data.startDate,
                        endDate: data.endDate,
                        channelList: channelList,
                        top: data.top,
                        effective: data.effective,
                        medias: medias,
                        popupTips: data.popupTips,
                        dotTips: data.dotTips,
                        jumpLink: data.jumpLink,
                        jumpMode: data.jumpMode,
                        contentLink: data.contentLink,
                        lang: data.lang
                    }
                }).then(res => {
                    this.reloadAxiosAll(false,'NoticeConfig');
                    this.$message({
                        type: 'success',
                        message: '发送成功!'
                    })
                    this.sendNoticeShow = false;
                    this.getNoticeData();
                })

            },

            // 复制
            copyContent(e) {
                noticeApi.noticeSend({
                    token: this.token,
                    noticeForm: {
                        type: e.type,
                        title: e.title,
                        content: e.content,
                        startDate: e.startDate,
                        endDate: e.endDate,
                        channelList: e.channelList,
                        medias: e.medias,
                        top: e.top,
                        effective: false,
                    }
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '复制成功!'
                    })
                    this.getNoticeData();
                })
            },

            // 移至草稿箱
            moveToDraft(e) {
                noticeApi.noticeEdit({
                    token: this.token,
                    noticeForm: {
                        id: e.id,
                        type: e.type,
                        title: e.title,
                        content: e.content,
                        startDate: e.startDate,
                        endDate: e.endDate,
                        channelList: e.channelList,
                        medias: e.medias,
                        top: e.top,
                        effective: false,
                    }
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '移至草稿箱成功!'
                    })
                    this.reloadAxiosAll(false,'NoticeConfig');
                    this.getNoticeData();
                })

            },

            onEditorChange({ quill, html, text }) {
                var data = quill.editor.delta.ops;
                var jsonData = [];
                data.forEach(item => {
                    if (item.attributes!==undefined && item.attributes.link!==undefined) {
                        jsonData.push({
                            string: item.insert,
                            face: {
                                color: (item.attributes!==undefined && item.attributes.color!==undefined)?item.attributes.color:'#ffffff',
                                dilate: (item.attributes!==undefined && item.attributes.bold!==undefined)?'0.55':'0.52',
                                softness: '0.07'
                            },
                            hyperlink: item.attributes.link,
                            u: (item.attributes!==undefined && item.attributes.underline!==undefined)?item.attributes.underline:false
                        })
                    } else {
                        jsonData.push({
                            string: item.insert,
                            face: {
                                color: (item.attributes!==undefined && item.attributes.color!==undefined)?item.attributes.color:'#ffffff',
                                dilate: (item.attributes!==undefined && item.attributes.bold!==undefined)?'0.55':'0.52',
                                softness: '0.07'
                            },
                            u: (item.attributes!==undefined && item.attributes.underline!==undefined)?item.attributes.underline:false
                        })
                    }
                })
                this.noticeSendContent = html;
                this.noticeSendContentData = jsonData;
            },

            showUploadBanner() {
                this.uploadBannerShow = true;
            },

            handleBannerSuccess(res, file) {
                this.bannerUrl = URL.createObjectURL(file.raw);
                if (res.msg == '请求成功') {
                    this.$message({
                        type: 'success',
                        message: '上传成功!'
                    })
                    var content = res.content;
                    this.changeNoticePng(content);
                }
            },

            updateBannerSuccess(res, file) {
                // if (res.msg == '请求成功') {
                //     this.$message({
                //         type: 'success',
                //         message: '上传成功!'
                //     })
                //     this.noticePngData[this.uploadBannerIndex].png = res.content;
                //     this.changeNoticePng();
                // }
            },

            beforeBannerUpload(file) {
                const isPNG = file.type === 'image/png';

                if (!isPNG) {
                    this.$message.error('上传图片只能是 PNG 格式!');
                }
                return isPNG;
            },

            onEditorEditChange({ quill, html, text }) {
                this.noticeEditContent = html;

                var data = quill.editor.delta.ops;
                var jsonData = [];
                data.forEach(item => {
                    if (item.attributes!==undefined && item.attributes.link!==undefined) {
                        jsonData.push({
                            string: item.insert,
                            face: {
                                color: (item.attributes!==undefined && item.attributes.color!==undefined)?item.attributes.color:'#ffffff',
                                dilate: (item.attributes!==undefined && item.attributes.bold!==undefined)?'0.55':'0.52',
                                softness: '0.07'
                            },
                            hyperlink: item.attributes.link,
                            u: (item.attributes!==undefined && item.attributes.underline!==undefined)?item.attributes.underline:false
                        })
                    } else {
                        jsonData.push({
                            string: item.insert,
                            face: {
                                color: (item.attributes!==undefined && item.attributes.color!==undefined)?item.attributes.color:'#ffffff',
                                dilate: (item.attributes!==undefined && item.attributes.bold!==undefined)?'0.55':'0.52',
                                softness: '0.07'
                            },
                            u: (item.attributes!==undefined && item.attributes.underline!==undefined)?item.attributes.underline:false
                        })
                    }
                })
                this.noticeEditContentData = jsonData;
            },

            onEditorSendChange({ quill, html, text }) {
                this.sendConfirmNoticeContent = html;

                var data = quill.editor.delta.ops;
                var jsonData = [];
                data.forEach(item => {
                    if (item.attributes!==undefined && item.attributes.link!==undefined) {
                        jsonData.push({
                            string: item.insert,
                            face: {
                                color: (item.attributes!==undefined && item.attributes.color!==undefined)?item.attributes.color:'#ffffff',
                                dilate: (item.attributes!==undefined && item.attributes.bold!==undefined)?'0.55':'0.52',
                                softness: '0.07'
                            },
                            hyperlink: item.attributes.link,
                            u: (item.attributes!==undefined && item.attributes.underline!==undefined)?item.attributes.underline:false
                        })
                    } else {
                        jsonData.push({
                            string: item.insert,
                            face: {
                                color: (item.attributes!==undefined && item.attributes.color!==undefined)?item.attributes.color:'#ffffff',
                                dilate: (item.attributes!==undefined && item.attributes.bold!==undefined)?'0.55':'0.52',
                                softness: '0.07'
                            },
                            u: (item.attributes!==undefined && item.attributes.underline!==undefined)?item.attributes.underline:false
                        })
                    }
                })
                this.sendConfirmNoticeContentData = jsonData;
            },

            // 更新公告图
            changeNoticePng(content) {
                if (content !== '' && content !== undefined) {
                    this.noticePngData.push({
                        png: content,
                        link: this.uploadBannerLink
                    });
                }

                noticeApi.modifyBanner({
                    token: this.token,
                    noticePngForm: this.noticePngData
                }).then(res => {
                    this.reloadAxiosAll(false,'LoginConfiguration');
                    this.loadNoticeInfo();
                    this.uploadBannerLink = '';
                })
            },

            // 公告图信息
            noticeInfo() {
                noticeApi.bannerInfo(this.token).then(res => {
                    var bucketName = res.bucketName;
                    var endpoint = res.endpoint;
                    this.noticePngPrefix = "http://" + bucketName + "." + endpoint + "/";
                })
            },

            upNoticePng(index) {
                if (index != 0) {
                    this.noticePngData[index] = this.noticePngData.splice(index - 1, 1, this.noticePngData[index])[0];
                } else {
                    this.noticePngData.push(this.noticePngData.shift());
                }
                this.changeNoticePng();
            },

            downNoticePng(index) {
                if (index != this.noticePngData.length - 1) {
                    this.noticePngData[index] = this.noticePngData.splice(index + 1, 1, this.noticePngData[index])[0];
                } else {
                    this.noticePngData.unshift(this.noticePngData.splice(index, 1)[0]);
                }
                this.changeNoticePng();
            },

            delNoticePng(index) {
                this.noticePngData.splice(index,1);
                this.changeNoticePng();
            },

            // 渠道列表
            getChannelsList() {
                configSettingApi.channelList({
                    token: this.token
                }).then(res => {
                    this.channelData = res;
                })
            },

            // 媒体值列表
            getMediasList() {
                configSettingApi.mediaList({
                    token: this.token
                }).then(res => {
                    this.mediaData = res;
                })
            },
            // 重载游戏服
            reloadAxiosAll(onlyLogin,clzName) {
                let self = this;
                self.resultShow = true;
                self.resultArray = [];

                self.reloadAxioxLogin();
                if (!onlyLogin) {
                    self.loginInfoGame.forEach(loginInfoGameItem => {
                        self.reloadGameItem(loginInfoGameItem,clzName);
                    })
                }
            },
            /**
             * 重载单个游戏服
             * @param reloadGameInfo
             */
            reloadGameItem(reloadGameInfo,clzName){
                let self = this;
                let balanceIps = reloadGameInfo.inner_urls.split(';');
                balanceIps.forEach(item => {
                    if ('' != item) {
                        self.resultArray.push({
                            server_url: item,
                            server_name: reloadGameInfo.server_name,
                            resStatus: '0'
                        });
                        let reloadForm = {
                            uri: item,
                            type: 'game',
                            className: clzName,
                            serverName: reloadGameInfo.server_name
                        }
                        gameApi.gameReloadConfig({
                            token: self.token,
                            reloadForm: reloadForm
                        }).then(res => {
                            self.resultArray.forEach(resultItem => {
                                if (resultItem.server_url == reloadForm.uri) {
                                    resultItem.resStatus = res.resStatus
                                }
                            })
                        })
                    }
                })
            },
            /**
             * 登录服重载
             */
            reloadAxioxLogin(){
                let self = this;
                self.yunweiLoginList.forEach((yunweiLoginInfo) => {
                    self.resultArray.push({
                        server_url: yunweiLoginInfo.server_url,
                        server_name: yunweiLoginInfo.server_name,
                        resStatus: '0'
                    });
                    let reloadForm =
                        {
                            loginUri: yunweiLoginInfo.server_url,
                            type: yunweiLoginInfo.type,
                            className: 'NoticeConfig',
                            serverName: yunweiLoginInfo.server_name
                        };

                    loginApi.loginReloadConfig({
                        token: self.token,
                        reloadForm: reloadForm
                    }).then(res => {
                        self.resultArray.forEach(resultItem => {
                            if (resultItem.server_url == reloadForm.loginUri) {
                                resultItem.resStatus = res.resStatus
                            }
                        })
                        console.log("登录服信息列表重载成功")
                    })
                })
            },
        },
        components: {
        }
    }
</script>

<style lang="less">
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 492.5px;
        height: 62px;
        line-height: 62px;
        text-align: center;
    }
    .avatar {
        width: 492.5px;
        height: 62px;
        display: block;
    }

    .avatar-limit {
        color: red;
    }

    /*.el-dialog__body {*/
    /*color: #ffffff;*/
    /*}*/

    /*.ql-editor.ql-blank::before {*/
    /*color: #ffffff;*/
    /*}*/

    .ql-container.ql-snow {
        color: #ffffff !important;
        background-color: #233858 !important;
    }

    .ql-editor.ql-blank::before {
        color: #ffffff !important;
    }
</style>

<style scoped lang="less">
    .notice-tip {
        color: red;
        margin-bottom: 10px;
    }

    .notice-top-tip {
        color: red;
    }

    .editor-quill {
        margin-bottom: 30px;
        height: 600px;
    }

    .notice-png-list {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
</style>



// WEBPACK FOOTER //
// src/views/maintenance/notice_manager.vue